import {
  Box,
  Button,
  Flex,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  VStack,
} from '@chakra-ui/react';
import loadable from '@loadable/component';
import { default as React } from 'react';
import { useIntl } from 'react-intl';
import Coupon from '../../../../../images/background/list-coupon.png';
import { ECommerceOrdersItems } from '../../../../../models/purchaseHistory';
import { Discount, Maybe } from '../../../../../models/shop';

type ViewCouponInfoProp = {
  isOpen: boolean;
  onClose: () => void;
  detail: ECommerceOrdersItems;
};
const FormatDate = loadable(
  () => import('../../../../../components/FormatDate')
);
const ViewCouponInfo = (props: ViewCouponInfoProp) => {
  const { isOpen, onClose, detail } = props;
  const intl = useIntl();
  return (
    <Modal
      isCentered
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={false}
    >
      <ModalOverlay background="#000000b3" />
      <ModalContent maxW={{ mobile: '348px', sm: '480px' }} rounded={20}>
        <ModalBody p={{ mobile: '16px 16px 24px', sm: '32px' }}>
          <VStack width={'100%'} alignItems={'baseline'}>
            <VStack
              width={'100%'}
              alignItems={'baseline'}
              mt={'0px !important'}
            >
              <Box
                fontWeight={700}
                fontSize={17}
                lineHeight={'20px'}
                textTransform={'uppercase'}
              >
                {intl.formatMessage({ id: 'ListDiscounts' })}
              </Box>
              {detail &&
                detail.total &&
                detail.total.discounts &&
                detail.total.discounts.length > 0 &&
                detail.total.discounts.map(
                  (discount: Maybe<Discount>, idx: number) => (
                    <Box key={idx} w={'100%'} mt={'0px !important'}>
                      <Box
                        mt={{ mobile: '16px', sm: '24px' }}
                        rounded={20}
                        p={{ mobile: '16px', sm: '24px' }}
                        boxShadow={'0px 0px 15px rgba(0, 0, 0, 0.24)'}
                        zIndex={2}
                        pos={'relative'}
                        overflow={'hidden'}
                        bg={'#FFF'}
                        _after={{
                          content: "''",
                          bgImage: `url(${Coupon})`,
                          bgSize: '100%',
                          w: '90px',
                          h: '63px',
                          bgRepeat: 'no-repeat',
                          pos: 'absolute',
                          right: '-10px',
                          bottom: '-10px',
                          opacity: '0.2',
                        }}
                      >
                        <Flex
                          fontWeight={500}
                          fontSize={{ mobile: '13px', sm: '15px' }}
                          lineHeight={{ mobile: '15px', sm: '18px' }}
                        >
                          {intl.formatMessage(
                            {
                              id: 'MyAccountUtilitiesPurchasedJapanCouponsCode',
                            },
                            {
                              name: (
                                <Box ml={'5px'} fontWeight={{ mobile: '700' }}>
                                  {discount && discount.label
                                    ? discount.label
                                    : ''}
                                </Box>
                              ),
                            }
                          )}
                        </Flex>
                        <Flex
                          mt={'12px'}
                          fontWeight={500}
                          fontSize={{ mobile: '13px', sm: '15px' }}
                          lineHeight={{ mobile: '15px', sm: '18px' }}
                        >
                          {intl.formatMessage(
                            { id: 'MyAccountUtilitiesPurchasedOrderDate' },
                            {
                              date: (
                                <Box ml={'5px'}>
                                  <FormatDate
                                    date={
                                      new Date(
                                        detail.order_date.replace(/-/g, '/')
                                      )
                                    }
                                    fontWeight={{ mobile: '700' }}
                                  />
                                </Box>
                              ),
                            }
                          )}
                        </Flex>
                      </Box>
                      <Box
                        width={'calc(100% - 32px)'}
                        height={'24px'}
                        margin={'-16px auto 0 !important'}
                        background={'#C0C0C0'}
                        boxShadow={'0px 0px 15px rgba(0, 0, 0, 0.24)'}
                        borderRadius={'20px'}
                      />
                    </Box>
                  )
                )}
              <HStack
                marginTop={{
                  mobile: '24px !important',
                  sm: '32px !important',
                }}
                width={'100%'}
                justifyContent={'center'}
              >
                <Button
                  variant={'secondarySkyTrak'}
                  fontSize={13}
                  lineHeight={'18px'}
                  h={'44px'}
                  maxWidth={'160px'}
                  width={'100%'}
                  onClick={onClose}
                >
                  {intl.formatMessage({
                    id: 'MyAccountUtilitiesPurchasedCloseViewBilling',
                  })}
                </Button>
              </HStack>
            </VStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ViewCouponInfo;
